import { reduce } from 'lodash/fp';
import { useMemo } from 'react';
import { useOidc } from '../Oidc';
import { getStoreKey } from './PowerApps.utils';

/*
  Returns a suffix key list in the same order you pass the original key names 
 */
export const usePowerAppsCookieKeys = (cookieKeys: string[]): string[] => {
  const { userData } = useOidc();
  return useMemo(() => {
    const profileSub = userData?.profile?.sub;
    return reduce(
      (prevValue, currentKey) => {
        return [...prevValue, getStoreKey(currentKey, profileSub)];
      },
      [] as string[],
      cookieKeys || [],
    );
  }, [userData?.profile?.sub, cookieKeys]);
};
